"use client";

import React from "react";
import { Typography } from "@material-tailwind/react";
import Image from "next/image";

interface AboutusImageBackgroundCardProps {
  image: string;
}

export function AboutusImageBackgroundCard({
  image,
}: AboutusImageBackgroundCardProps) {
  return (
    <div className="rounded-xl w-100 lg:mb-0 mb-12 shadow-lg overflow-hidden ">
    <img
  
      src={image}
      className="w-200 h-200 object-cover shadow-lg border-4 border-white"
      style={{
        marginTop: "15px",
        borderRadius: "10px",
        borderWidth: "10px",
        borderColor: "white",
      }}
    />
  </div>
  );
}
export default AboutusImageBackgroundCard;
